import React, { Component } from "react";
import { connect } from "react-redux";

import {
  ButtonGroup,
  ButtonOutline,
  ButtonOrange
} from "components/Global/Modal/Layout/Buttons";
import StyleWrapper from "components/Global/Modal/Layout/StyleWrapper";
import { Div } from "components/Base";
import EventDaysEditor from "components/Global/Editors/EventDaysEditor";

import { eventDetails } from "redux/modules/event/selectors";

const decorator = connect(state => ({
  dayGroups: eventDetails(state).date_groups,
  startDate: eventDetails(state).date_from,
  endDate: eventDetails(state).date_to
}));

class AddMultiDayVariantModal extends Component {
  state = {
    dates: []
  };

  onDaySelect = ({ value }) => {
    this.setState({
      dates: value
    });
  };

  onSave = () => {
    this.props.onSave(this.state.dates);
    this.props.hideModal();
  };

  render() {
    const { dayGroups, startDate, endDate, hideModal } = this.props;
    const isValid = this.state.dates.length > 0;

    return (
      <StyleWrapper heading="Create a multi-day pass" hideModal={hideModal}>
        <Div>
          <Div fw={3} fs={4} color="gray7" mt={1} mb={3}>
            Select the days this pass is valid for
          </Div>

          <Div display="row.center.center" mb={3}>
            <EventDaysEditor
              onChange={this.onDaySelect}
              value={{ value: this.state.dates }}
              endDate={endDate}
              startDate={startDate}
              dayGroups={dayGroups}
            />
          </Div>
        </Div>
        <ButtonGroup>
          <ButtonOrange
            title="Add Variant"
            onClick={isValid ? this.onSave : undefined}
            disabled={!isValid}
          />
          <ButtonOutline title="Cancel" onClick={hideModal} />
        </ButtonGroup>
      </StyleWrapper>
    );
  }
}

export default decorator(AddMultiDayVariantModal);
